<template>
  <div>
    <Row :gutter="4">
      <Col span="5">
        <Input search v-model="subjectKeywordSearchKey" :placeholder="$t('configuration_management.mailbox_management.queryByKeyWord')" @on-search="searchSchedule()"/>
      </Col>
      <Col span="5">
        <add-subjectKeyword></add-subjectKeyword>
      </Col>
    </Row>
  </div>
</template>
<script>
  import AddSubjectKeyword from './AddSubjectKeyword'
  import TableSubjectKeyword from './TableSubjectKeyword'

  const tableSubjectKeyword = TableSubjectKeyword;
  export default {
    name: 'subjectKeywordSearch',
    components: {
      AddSubjectKeyword
    },
    data() {
      return {
        subjectKeywordSearchKey: '',
        subjectKeywordSearchName: ''
      }
    },
    methods: {
      searchSchedule() {
        eventBus.$emit('subjectKeywordSearchName', this.subjectKeywordSearchKey);
        tableSubjectKeyword.methods.showAll();
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/monitor_mailbox_configuration/SubjectKeywordSearch.vue